/**
 * The centered card every auth screen sits in: BCE logo, a heading, and the
 * form. One component so the five auth pages cannot drift apart visually.
 */
export interface AuthCardProps {
  readonly title: string;
  readonly subtitle?: string;
  readonly children: React.ReactNode;
}

/**
 * Renders the shared auth screen chrome.
 *
 * @param props - Heading copy and the form.
 * @returns The auth layout.
 */
export function AuthCard({ title, subtitle, children }: AuthCardProps): React.ReactElement {
  return (
    <main className="flex min-h-screen items-center justify-center bg-portal-bg px-4 py-8">
      <div className="w-full max-w-[440px] rounded-portal-card border border-portal-line bg-white p-8 shadow-portal-card">
        <div className="text-center">
          <img
            src="/images/logo.png"
            alt="Best Corporate Events"
            className="mx-auto mb-6 h-12 w-auto object-contain"
          />
          <h1 className="text-portal-section font-bold tracking-[-0.4px]">{title}</h1>
          {subtitle ? <p className="mt-1 text-portal-small text-portal-muted">{subtitle}</p> : null}
        </div>

        <div className="mt-6">{children}</div>
      </div>
    </main>
  );
}
